import React, {Component} from 'react';
import {InputText} from 'primereact/inputtext';
import {Calendar} from 'primereact/calendar';
import {RadioButton} from 'primereact/radiobutton';
import {Button} from 'primereact/button';
import {FileUpload} from 'primereact/fileupload';
import {Panel} from 'primereact/panel';
import '@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css';
import * as auth from "../../actions/auth";
import * as management from "../../actions/management";
import connect from "react-redux/es/connect/connect";
import {Dialog} from "primereact/dialog";
import {InputTextarea} from "primereact/inputtextarea";
import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
import default_profil from "../../resources/images/logo/user2.png";
import {Dropdown} from 'primereact/dropdown';
import {addLocale} from "primereact/api";
import {Toast} from "primereact/toast";
import {Message} from "primereact/message";


class UserProfile extends Component {

    constructor(props) {
        super(props);

        this.state = {
            id: "",
            image_file_max_size: 400,
            pers_id: null,
            user_username: "",
            user_createtime: "",
            user_email: "",
            pers_email: "",
            new_pers_contact_content: "",
            user_address: "",
            confirmPassword: "",
            user_business_address: "",
            pers_contact_uptate_list: [],
            user_password: "",
            user_id: null,
            pers_tcid: "",
            pers_name: "",
            pers_surname: "",
            pers_birthday: "",
            pers_photo: default_profil,
            pers_title: "",
            inst_id: null,
            // dept_id: null,
            ctyp_name: "",
            gend_id: null,
            selectedOption: "",
            data: null,
            institutions: [],
            departments: [],
            gender: [],
            edit_contact_data: [],
            contact_types: [],
            graduations: [],
            user_graduations: [],
            ugt_id: null,
            upg_schoolname: '',
            upg_starttime: null,
            upg_graduationtime: null,
            graduation_row_index: null,
            graduation_popup_visibility: false,
            pers_workinginstitute: '',
            contact_edit_content: "",
            contact_edit_row_index: "",
            contact_edit_id: "",
            will_be_deleted_pcon_id: null,
            will_be_deleted_row_index: null,
            selectedInstID: [],
            contacts: [],
            user_role_group_name: [],
            contact_info_edit: false,
            delete_popup: false,
        };
        this.noMatchPasswordMessage = "Şifreler Aynı Değil!",
            this.nowDate = new Date().getFullYear();

        addLocale('tr', {
            firstDayOfWeek: 0,
            dayNames: ["pazartesi", "salı", "çarşamba", "perşembe", "cuma", "cumartesi", "pazar"],
            dayNamesShort: ["pzt", "sal", "çar", "per", "cum", "cmt", "pzr"],
            dayNamesMin: ["PT", "SA", "ÇA", "PE", "CU", "CT", "PA"],
            monthNames: ["ocak", "şubat", "mart", "nisan", "mayıs", "haziran", "temmuz", "ağustos", "eylül", "ekim", "kasım", "aralık"],
            monthNamesShort: ["ocak", "şub", "mart", "nisan", "mayis", "haziran", "temmuz", "ağus", "eyl", "ekm", "kas", "aralik"]
        });

        this.onUpload = this.onUpload.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.logChange = this.logChange.bind(this);
        this.createUserData = this.createUserData.bind(this);
        this.getAllInstitutions = this.getAllInstitutions.bind(this);
        this.getDepartments = this.getDepartments.bind(this);
        this.getAllContactTypes = this.getAllContactTypes.bind(this);
        this.showSuccess = this.showSuccess.bind(this);
        this.addContact = this.addContact.bind(this);
        this.editContactInitialize = this.editContactInitialize.bind(this);
        this.saveUpdateContact = this.saveUpdateContact.bind(this);
        this.deleteContact = this.deleteContact.bind(this);
        this.listContainsValue = this.listContainsValue.bind(this);
        this.createContactObject = this.createContactObject.bind(this);
        this.deletePopupClick = this.deletePopupClick.bind(this);
        this.deletePopupHide = this.deletePopupHide.bind(this);
        this.formValid = this.formValid.bind(this);
        this.institutionInitalize = this.institutionInitalize.bind(this);
        this.getGenders = this.getGenders.bind(this);
        this.getGraduations = this.getGraduations.bind(this);
        this.addUpdateGraduation = this.addUpdateGraduation.bind(this);
        this.graduationtimeTemplate = this.graduationtimeTemplate.bind(this);
        this.starttimeTemplate = this.starttimeTemplate.bind(this);

    }

    onUpload() {

    }
    selectUser(user_username) {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        fetch(`/api/user/list/${user_username}/`, {headers, method: "GET"})
            .then(res => {
                if (res.status < 500) {
                    return res.json().then(data => {
                        return {status: res.status, data};
                    })
                } else {
                    console.log("Server Error!");
                    throw res;
                }
            })
            .then(res => {
                if (res.status === 200) {
                    let data = res.data.results
                    // });
                    this.createUserData(data);
                    this.getRequest(this.state.role_group_path, "role_group");
                } else if (res.status === 401 || res.status === 403) {

                    throw res.data;
                }
            })
    }

    showSuccess(message) {
        this.growl.show({severity: 'success', summary: message, detail: ''});
    }

    showError(message) {
        this.growl.show({severity: 'error', summary: message, detail: ''});
    }

    deletePopupClick(pcon_id, rowIndex) {
        this.setState({delete_popup: true});
        this.setState({will_be_deleted_pcon_id: pcon_id});
        this.setState({will_be_deleted_row_index: rowIndex});

    }

    deletePopupHide() {
        this.setState({delete_popup: false});
    }

    editContactInitialize(pcon_id, content, row_index) {
        this.setState({
            contact_edit_id: pcon_id,
            contact_edit_content: content,
            contact_edit_row_index: row_index,
            contact_info_edit: true,
        });
    }

    addContact() {

        let new_pers_contact_content = this.state.new_pers_contact_content;
        let contact_arr = this.state.contacttype.split("--");
        let new_pers_contact_id = contact_arr[0];
        let new_pers_contact_name = contact_arr[1];

        let contacts_list = [];

        if (new_pers_contact_content !== "" && !(this.listContainsValue(this.state.contacts, new_pers_contact_content))) {
            contacts_list.push(this.createContactObject(new_pers_contact_id, null, new_pers_contact_name,
                this.state.pers_id, new_pers_contact_content, false));
        }
        if (contacts_list.length > 0) {
            this.setState({pers_contact_uptate_list: this.state.pers_contact_uptate_list.concat(contacts_list)});
            this.setState({contacts: this.state.contacts.concat(contacts_list)});
            this.setState({display: false});
        }
    }

    deleteContact(pcon_id, rowIndex) {
        //var index = array.indexOf(e.target.value)
        let contacts_list = this.state.contacts;
        let del_con_obj = contacts_list[rowIndex];
        contacts_list.splice(rowIndex, 1);
        this.setState({contacts: contacts_list});
        if ((typeof pcon_id) == "number") {
            del_con_obj.pcon_flag_delete = true;
            this.setState({pers_contact_uptate_list: this.state.pers_contact_uptate_list.concat(del_con_obj)});
        }
        contacts_list = this.state.pers_contact_uptate_list;

        for (let i = 0; i < contacts_list.length; i++) {
            if (contacts_list[i].pcon_id === pcon_id) {
                contacts_list.splice(i, 1);
                this.setState({pers_contact_uptate_list: contacts_list});
            }
        }
        this.deletePopupHide();
    }

    createContactObject(ctyp_id, pcon_id, ctyp_name, pers_id, pcon_content, status) {
        return (
            {
                pcon_id: pcon_id,
                pers_id: pers_id,
                pcon_content: pcon_content,
                pcon_flag_delete: status,
                ctyp: {
                    ctyp_id: ctyp_id,
                    ctyp_name: ctyp_name,
                }
            }
        )
    }

    listContainsValue(list, value) {
        for (let i = 0; i < list.length; i++) {
            if (list[i].pcon_content === (value)) {
                return true;
            }
        }
        return false;
    }

    formValid() {
        let formIsValid = true;
        let user_password = this.state.user_password;
        let confirmPassword = this.state.confirmPassword;
        if ((user_password === confirmPassword) || (user_password === "" && confirmPassword === "")) {
            return true;
        } else {
            formIsValid = false;
        }
        return formIsValid;
    }

    onSubmit = e => {
        e.preventDefault();
        if (this.formValid()) {
            let person_data = {
                pers_photo: this.state.pers_photo,
                inst_id: parseInt(this.state.inst_id),
                // dept_id: parseInt(this.state.dept_id),
                pers_title: this.state.pers_title,
                user_password: this.state.user_password,
                create_or_update_contacts: this.state.pers_contact_uptate_list,
                pers_workinginstitute: this.state.pers_workinginstitute,
                user_graduations: this.state.user_graduations
            };
            this.props.updateUserProfile(this.state.user_id, person_data);
            this.setState({pers_contact_uptate_list: []});
        } else {
            this.showError(this.noMatchPasswordMessage);
        }

    };

    componentDidMount() {
        let user_username = localStorage.getItem("user_username");
        this.selectUser(user_username);
        this.getAllInstitutions();
        this.getAllContactTypes();
        this.getGenders();
        this.getGraduations();
    }

    createUserData(person_detail) {
        if (person_detail !== undefined) {
            const user = person_detail[0];
            if (user !== undefined) {
                const person = user.person[0];
                const graduation = person.graduation;
                const person_birthday_date = new Date(person.pers_birthday);
                this.setState({
                    user_username: user.user_username,
                    user_email: user.user_email,
                    user_id: parseInt(user.user_id),
                    pers_id: parseInt(person.pers_id),
                    pers_tcid: person.pers_tcid,
                    pers_name: person.pers_name,
                    pers_title: person.pers_title,
                    pers_surname: person.pers_surname,
                    pers_birthday: person_birthday_date,
                    pers_detail: person.pers_detail,
                    pers_workinginstitute: person.pers_workinginstitute,
                    gend_id: parseInt(person.gend.gend_id),
                    gend_name: person.gend.gend_name,
                    inst_id: person.inst_id ? parseInt(person.inst_id) : null,
                    // dept_id: person.dept ? parseInt(person.dept.dept_id) : null,
                    contacts: person.contact,
                    user_role_group_name: user.role_group,
                    user_graduations: graduation,
                });
                if (person.pers_photo != null) {
                    this.setState({pers_photo: 'data:image/png;base64,' + person.pers_photo});
                }
                if (person.dept)
                    this.getDepartments(person.dept.inst.inst_id);
            } else {
                this.setState({
                    user_username: user.user_username,
                    user_email: user.user_email,
                    user_id: parseInt(user.user_id)
                });
            }
        }

    }

    logChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) {
            if (nextProps.management.type === 'SELECT_USER') {
                let person_detail = nextProps.management.management;
                this.createUserData(person_detail);
            } else if (nextProps.management.type === 'UPDATE_PERSON' && this.props.management !== nextProps.management) {
                if (nextProps.management.management.result === 1) {
                    this.showSuccess(nextProps.management.management.message);

                } else {
                    this.showError(nextProps.management.management.message);
                }
            } else if (nextProps.management.type === 'DELETE_CONTACT' && this.props.management !== nextProps.management) {
                if (nextProps.management.management.result === 1) {
                    this.showSuccess(nextProps.management.management.message);

                } else {
                    this.showError(nextProps.management.management.message);
                }
            }


        }
    }

    getAllInstitutions() {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/user_institutions/", {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        this.setState({institutions: res.data});

                    } else if (res.status === 401) {
                        this.props.loadUser();
                        throw res.data;
                    } else if (res.status === 403) {
                        throw res.data;
                    }
                })
        }
    }

    getGenders() {

        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            console.log("inside handleGetJson");
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/gender/", {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        this.setState({gender: res.data});

                    } else if (res.status === 401 || res.status === 403) {
                        //dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
                        throw res.data;
                    }
                })
        }
    }

    getAllContactTypes() {

        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/contact_types/", {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        this.setState({contact_types: res.data});
                    } else if (res.status === 401 || res.status === 403) {
                        //dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
                        throw res.data;
                    }
                })
        }
    }

    getDepartments(inst_id) {

        if (inst_id !== "" && Number.isInteger(parseInt(inst_id))) {
            let headers = {"Content-Type": "application/json"};
            let token = localStorage.getItem("token");
            if (token) {
                headers["Authorization"] = `Token ${token}`;
                fetch(`/api/user_departments/${inst_id}/`, {headers,})
                    .then(res => {
                        if (res.status < 500) {
                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {

                            this.setState({departments: res.data});
                        } else if (res.status === 401 || res.status === 403) {
                            throw res.data;
                        }
                    })
            }
        }
    }

    handleChange(e) {
        let files = e.files;
        let allFiles = [];
        for (let i = 0; i < files.length; i++) {
            let file = files[i];
            let reader = new FileReader();
            reader.readAsDataURL(file);
            let file_size = Math.round(file.size / 1000);
            reader.onload = () => {
                let fileInfo = {
                    name: file.name,
                    type: file.type,
                    size: file_size + ' kB',
                    base64: reader.result,
                    file: file,
                };
                if (file_size < this.state.image_file_max_size) {
                    this.setState({pers_photo: reader.result});
                } else {
                    alert("Resim Boyutu Çok Büyük Lütfen " + this.state.image_file_max_size + " KB'den Küçük Boyutlu Resim Seçiniz")
                }
            }
        }
    }

    saveUpdateContact() {
        let contacts_list = this.state.contacts;
        let selected_item = contacts_list[this.state.contact_edit_row_index];
        let update = this.createContactObject(selected_item.ctyp_id, this.state.contact_edit_id, selected_item.ctyp_name,
            this.state.pers_id, this.state.contact_edit_content, false);
        contacts_list[this.state.contact_edit_row_index] = update;
        this.setState({contacts: contacts_list});
        this.setState({pers_contact_uptate_list: this.state.pers_contact_uptate_list.concat(update)});
        this.setState({contact_info_edit: false});
    }

    institutionInitalize(inst_id) {
        this.setState({
            inst_id: inst_id,
            // dept_id: null
        });
        this.getDepartments(inst_id)
    }

    contacttypeButtons(rowData, column) {
        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-6">
                    <Button
                        type="button"
                        // onClick = {this.deletePopupClick}
                        onClick={() => this.deletePopupClick(rowData['pcon_id'], column.rowIndex)}
                        //onClick = {() => this.deleteContact(rowData['pcon_id'],column.rowIndex)}
                        title="Sil"
                        icon="pi pi-trash"
                        className="p-button-danger">
                    </Button>
                </div>
                <div className="p-col-12 p-md-6">
                    <Button
                        type="button"
                        title="Düzenle"
                        icon="pi pi-pencil"
                        className="p-button-warning"
                        onClick={() => this.editContactInitialize(rowData['pcon_id'], rowData['pcon_content'], column.rowIndex)}>
                    </Button>
                </div>
            </div>
        );
    }

    dateFormatConvert(date) {
        const mont = date.getMonth() + 1;
        const day = date.getDate();
        const year = date.getFullYear();
        return day + '/' + mont + '/' + year;
    }

    dateDbFormat(date) {
        const mont = date.getMonth() + 1;
        const day = date.getDate();
        const year = date.getFullYear();
        return year + '-' + mont + '-' + day;
    }

    getGraduations() {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/user/graduations/", {headers,})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        this.setState({graduations: res.data});

                    } else if (res.status === 401 || res.status === 403) {
                        //dispatch({type: "AUTHENTICATION_ERROR", data: res.data});
                        throw res.data;
                    }
                })
        }
    }

    graduationButtons(rowData, column) {
        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-6">
                    <Button
                        type="button"
                        onClick={() => this.deleteGraduationPopupClick(column.rowIndex)}
                        title="Sil"
                        icon="pi pi-trash"
                        className="p-button-danger">
                    </Button>

                </div>
                <div className="p-col-12 p-md-6">
                    <Button
                        type="button"
                        title="Düzenle"
                        icon="pi pi-pencil"
                        className="p-button-warning"
                        onClick={() => this.editGraduationInitialize(rowData, column.rowIndex)}>
                    </Button>
                </div>
            </div>
        );
    }

    editGraduationInitialize(rowData, row_index) {
        this.setState({
            ugt_id: rowData.ugt.ugt_id,
            upg_schoolname: rowData.upg_schoolname,
            upg_graduationtime: new Date(rowData.upg_graduationtime),
            upg_starttime: new Date(rowData.upg_starttime),
            graduation_popup_visibility: true,
            graduation_row_index: row_index,
        });
    }

    graduationNameById(ugt_id) {
        const graduations = this.state.graduations;
        for (let i = 0; i < graduations.length; i++) {
            const graduation = graduations[i];
            if (graduation.ugt_id === ugt_id) {
                return graduation.ugd_name;
            }
        }
        return null;
    }

    onHideContactDialog() {
        this.setState({
            display: false,
            contacttype: undefined,
            new_pers_contact_content: "",
        })
    }

    contact_type_input() {
        if (this.state.contacttype) {
            const cont_type_name = this.state.contacttype.split("--")[1];
            if (cont_type_name === "Cep Telefonu") {
                return <div>
                    <InputText
                        value={this.state.new_pers_contact_content}
                        id="numbers"
                        minLength={11}
                        maxLength={11}
                        keyfilter="int"
                        onChange={(e) => this.setState({new_pers_contact_content: e.target.value})}/>

                </div>
            } else if (cont_type_name === "İş Telefonu") {
                return <div>
                    <InputText
                        value={this.state.new_pers_contact_content}
                        id="numbers"
                        keyfilter="num"
                        onChange={(e) => this.setState({new_pers_contact_content: e.target.value})}/>
                </div>
            } else if (cont_type_name === "E-Posta") {
                return <div>
                    <InputText
                        value={this.state.new_pers_contact_content}
                        onChange={(e) => this.setState({new_pers_contact_content: e.target.value})}/>
                </div>
            } else if (cont_type_name === "Ev Adresi") {
                return <div>
                    <InputTextarea
                        id="new_pers_contact_content"
                        name="new_pers_contact_content"
                        onChange={this.logChange}
                        rows={7}
                        cols={30}
                        autoResize={true}/>
                </div>
            } else if (cont_type_name === "İş Adresi") {
                return <div>
                    <InputTextarea
                        id="new_pers_contact_content"
                        name="new_pers_contact_content"
                        onChange={this.logChange}
                        rows={7}
                        cols={30}
                        autoResize={true}/>
                </div>
            } else {
                return null
            }
        }

    }

    addUpdateGraduation() {
        const state = this.state;
        if (state.upg_starttime !== null && state.upg_graduationtime !== null && state.upg_schoolname !== null) {

            if (state.graduation_row_index === null) {
                const data = {
                    "upg_id": null,
                    "upg_schoolname": state.upg_schoolname,
                    "upg_starttime": this.dateDbFormat(state.upg_starttime),
                    "upg_graduationtime": this.dateDbFormat(state.upg_graduationtime),
                    "upg_flag_delete": false,
                    "ugt": {
                        "ugt_id": state.ugt_id,
                        "ugd_name": this.graduationNameById(state.ugt_id)
                    }
                }
                this.setState({
                    user_graduations: this.state.user_graduations.concat(data),
                });
            } else {
                const graduations = this.state.user_graduations.slice()
                const data = {
                    "upg_id": graduations[state.graduation_row_index].upg_id,
                    "upg_schoolname": state.upg_schoolname,
                    "upg_starttime": this.dateDbFormat(state.upg_starttime),
                    "upg_graduationtime": this.dateDbFormat(state.upg_graduationtime),
                    "upg_flag_delete": false,
                    "ugt": {
                        "ugt_id": state.ugt_id,
                        "ugd_name": this.graduationNameById(state.ugt_id)
                    }
                }

                graduations[state.graduation_row_index] = data;
                this.setState({user_graduations: graduations});
            }
            this.setState({
                    graduation_popup_visibility: false,
                    graduation_row_index: null,
                }
            );
        } else {
            this.showError("Lütfen bütün form elemanlarını doldurunuz!");

        }
    }

    starttimeTemplate(rowData) {
        return this.dateFormatConvert(new Date(rowData.upg_starttime));
    }

    graduationtimeTemplate(rowData) {
        return this.dateFormatConvert(new Date(rowData.upg_graduationtime));
    }


    deleteGraduationPopupClick(rowIndex) {
        this.setState({delete_graduation_popup: true});
        this.setState({deleted_graduation_row_index: rowIndex});

    }


    deleteGraduation() {
        this.state.user_graduations.splice(this.state.deleted_graduation_row_index, 1)
        this.setState({delete_graduation_popup: false})
    }

    render() {
        const minDate = this.state.upg_starttime


        let instOptionItems = [];
        let deptOptionItems = [];
        let genderOptionItems = [];
        let contactTypesItems = [];

        let gend = this.state.gender;
        genderOptionItems = gend.map((gender) =>
            <div className="p-col-12" key={gender.gend_name}>
                <RadioButton
                    value={gender.gend_id}
                    inputId={gender.gend_name}
                    onChange={event => this.setState({gend_id: gender.gend_id})}
                    checked={this.state.gend_id === gender.gend_id}/>
                <label
                    htmlFor={gender.gend_name}
                    className="p-radiobutton-label">
                    {gender.gend_name}
                </label>
            </div>
        );


        const institutions = this.state.institutions;
        instOptionItems = institutions.map((inst) => (
                {"label": inst.inst_name, "value": inst.inst_id}
            )
        );

        // const departments = this.state.departments;
        // deptOptionItems = departments.map((dept) => (
        //         {"label": dept.dept_name, "value": dept.dept_id}
        //     )
        // );
        const contact_types = this.state.contact_types;
        contactTypesItems = contact_types.map((contact) => (
                {"label": contact.ctyp_name, "value": contact.ctyp_id + '--' + contact.ctyp_name}
            )
        );
        const graduation = this.state.graduations;
        const graduationItems = graduation.map((ugd) => (
                {"label": ugd.ugd_name, "value": ugd.ugt_id}
            )
        );
        const delete_popup_footer = (
            <div>
                <Button label="Evet"
                        icon="pi pi-check"
                        onClick={() => this.deleteContact(this.state.will_be_deleted_pcon_id, this.state.will_be_deleted_row_index)}/>
                <Button
                    label="Hayır"
                    icon="pi pi-times"
                    onClick={this.deletePopupHide}
                    className="p-button-secondary"/>
            </div>
        );
        const delete_graduation_popup_footer = (
            <div>
                <Button label="Evet"
                        icon="pi pi-check"
                        onClick={() => this.deleteGraduation()}/>
                <Button
                    label="Hayır"
                    icon="pi pi-times"
                    onClick={() => this.setState({delete_graduation_popup: false})}
                    className="p-button-secondary"/>
            </div>
        );

        return (
            <div className="p-fluid">
                <Toast ref={(el) => this.growl = el}/>
                <div className="p-grid">
                    <form onSubmit={this.onSubmit.bind(this)}>
                        <div className="p-col-12">
                            <div className="card card-w-title">
                                <center>
                                    <h1>Profil Bilgileri</h1>
                                    <div className="profile">
                                        <div>
                                            <img src={this.state.pers_photo} alt=""
                                                 style={{borderRadius: '50%', maxWidth: 130, maxHeight: 130}}/>
                                        </div>
                                    </div>
                                    <div className="p-col-5 p-md-3">
                                        <FileUpload
                                            uploadLabel="seç"
                                            chooseLabel="Fotoğraf Seçiniz"
                                            cancelLabel="iptal"
                                            onSelect={this.handleChange.bind(this)}
                                            name="file"
                                            style={{marginRight: '.25em'}}
                                            mode="basic"
                                            accept="image/jpg, image/jpeg, image/png"/>
                                    </div>
                                    <Panel header="Kişi Bilgileri" toggleable={true}>
                                        <div className="p-grid p-md-10">
                                            <div className="p-col-12 p-md-2">
                                                <label htmlFor="input">T.C </label>
                                            </div>
                                            <div className="p-col-12 p-md-10">
                                                <InputText value={this.state.pers_tcid}
                                                           onChange={this.logChange}
                                                           name="pers_tcid"
                                                           id="pers_tcid"
                                                           minLength={11}
                                                           maxLength={11}
                                                           keyfilter="int"
                                                           disabled={true}
                                                           required/>
                                            </div>
                                            <div className="p-col-12 p-md-2">
                                                <label htmlFor="input">Ad </label>
                                            </div>
                                            <div className="p-col-12 p-md-10">
                                                <InputText
                                                    value={this.state.pers_name}
                                                    onChange={this.logChange}
                                                    name="pers_name"
                                                    id="pers_name"
                                                    minLength={2}
                                                    maxLength={50}
                                                    keyfilter="alpha"
                                                    disabled={true}
                                                    required/>
                                            </div>
                                            <div className="p-col-12 p-md-2">
                                                <label htmlFor="input">Soyad</label>
                                            </div>
                                            <div className="p-col-12 p-md-10">
                                                <InputText
                                                    id="pers_surname"
                                                    value={this.state.pers_surname}
                                                    onChange={this.logChange}
                                                    name="pers_surname"
                                                    minLength={2}
                                                    maxLength={50}
                                                    keyfilter="alpha"
                                                    disabled={true}
                                                    required/>
                                            </div>
                                            <div className="p-col-12 p-md-2">
                                                <label htmlFor="input">E-Posta</label>
                                            </div>
                                            <div className="p-col-12 p-md-10">
                                                <InputText
                                                    id="user_email"
                                                    value={this.state.user_email}
                                                    onChange={this.logChange}
                                                    name="user_email"
                                                    minLength={2}
                                                    maxLength={50}
                                                    disabled={true}
                                                    required/>
                                            </div>
                                            <div className="p-col-12 p-md-2">
                                                <label htmlFor="input">Doğum Tarihi</label>
                                            </div>
                                            <div className="p-col-12 p-md-10">
                                                <Calendar
                                                    id="pers_birthday"
                                                    value={this.state.pers_birthday}
                                                    locale="tr"
                                                    name="pers_birthday"
                                                    dateFormat="dd/mm/yy"
                                                    onChange={this.logChange}
                                                    monthNavigator={true}
                                                    yearNavigator={true}
                                                    yearRange={"1910:" + this.nowDate}
                                                    disabled="true"/>
                                            </div>
                                            <div className="p-col-12 p-md-2">
                                                Cinsiyet
                                            </div>
                                            <div className="p-col-12 p-md-10"
                                                 align="left">
                                                <div className="p-grid">
                                                    <div className="p-col-12">
                                                        {genderOptionItems}
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="p-col-12 p-md-2">
                                                <label htmlFor="input">Kurum</label>
                                            </div>
                                            <div className="p-col-12 p-md-10">
                                                <Dropdown options={instOptionItems}
                                                          inputId="inst_id"
                                                          name="inst_id"
                                                          value={this.state.inst_id}
                                                          onChange={e => this.institutionInitalize(e.target.value)}
                                                          filter={true}
                                                          showClear={true}
                                                          placeholder="Lütfen Kurumunuzu Seçiniz"
                                                          emptyMessage="Kayıt Bulunamadı"
                                                />

                                            </div>
                                            {/*<div className="p-col-12 p-md-2">*/}
                                            {/*    <label htmlFor="input">Departman</label>*/}
                                            {/*</div>*/}
                                            {/*<div className="p-col-12 p-md-10">*/}
                                            {/*    <Dropdown options={deptOptionItems}*/}
                                            {/*              inputId="dept_id"*/}
                                            {/*              name="dept_id"*/}
                                            {/*              value={this.state.dept_id}*/}
                                            {/*              onChange={this.logChange}*/}
                                            {/*              filter={true}*/}
                                            {/*              showClear={true}*/}
                                            {/*              placeholder="Lütfen Departmanınızı Seçiniz"*/}
                                            {/*              emptyMessage="Kayıt Bulunamadı"*/}
                                            {/*    />*/}

                                            {/*</div>*/}
                                            <div className="p-col-12 p-md-2">
                                                <label htmlFor="input">Çalışılan Kurum</label>
                                            </div>
                                            <div className="p-col-12 p-md-10">
                                                <InputText id="pers_workinginstitute"
                                                           value={this.state.pers_workinginstitute}
                                                           onChange={this.logChange}
                                                           name="pers_workinginstitute"/>
                                                <div className="col-12 md:col-3">
                                                    <Message severity="info" text="Kurum ve departmanınız seçenekler arasında
                                                    bulunmuyor ise Çalışılan Kurum alanına kendi kurum bilginizi giriniz!"/>
                                                </div>
                                            </div>
                                            <div className="p-col-12 p-md-2">
                                                <label htmlFor="input">Ünvanı</label>
                                            </div>
                                            <div className="p-col-12 p-md-10">
                                                <InputText id="pers_title"
                                                           value={this.state.pers_title}
                                                           onChange={this.logChange}
                                                           name="pers_title"/>
                                            </div>
                                            <div className="p-col-12 p-md-2">
                                                <label htmlFor="input">Rol</label>
                                            </div>
                                            <div className="p-col-12 p-md-10">
                                                <div className="p-grid" style={{marginTop: '.0em'}}>
                                                    {
                                                        this.state.user_role_group_name.map((col, index) =>
                                                            <div key={index} className="p-col-3">
                                                                <div
                                                                    className="box"
                                                                    style={{backgroundColor: '#cce4f7'}}>
                                                                    {col.rolg.rolg_name}
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </Panel>
                                    <br/><br/>
                                    <Panel header="Kullanıcı Bilgileri" toggleable={true}>
                                        <div className="p-grid p-md-10">
                                            <div className="p-col-12 p-md-2">
                                                <label htmlFor="input">Kullanıcı Adı</label>
                                            </div>
                                            <div className="p-col-12 p-md-10">
                                                <InputText
                                                    id="user_username"
                                                    name="user_username"
                                                    value={this.state.user_username}
                                                    keyfilter="alpha"
                                                    disabled={true}
                                                    onChange={this.logChange}/>
                                            </div>
                                            {/*<div className="p-col-12 p-md-2">*/}
                                            {/*    <label htmlFor="input">Yeni Şifre </label>*/}
                                            {/*</div>*/}
                                            {/*<div className="p-col-12 p-md-10">*/}
                                            {/*    <Password id="user_password" name="user_password"*/}
                                            {/*              onChange={this.logChange}/>*/}
                                            {/*</div>*/}
                                            {/*<div className="p-col-12 p-md-2">*/}
                                            {/*    <label htmlFor="input">Şifre Tekrar</label>*/}
                                            {/*</div>*/}
                                            {/*<div className="p-col-12 p-md-10">*/}
                                            {/*    <Password id="confirmPassword" name="confirmPassword"*/}
                                            {/*              onChange={this.logChange}/>*/}
                                            {/*</div>*/}
                                        </div>
                                    </Panel>
                                    <br/><br/>


                                    <Panel header="Eğitim Bilgileri" toggleable={true}>

                                        <DataTable
                                            value={this.state.user_graduations}
                                            emptyMessage="Kayıt bulunamadı"
                                            reorderableColumns={true}>
                                            <Column
                                                header="İşlevler"
                                                body={this.graduationButtons.bind(this)}
                                                style={{textAlign: 'center', width: '6em'}}/>
                                            <Column
                                                field="upg_schoolname"
                                                header="Okul"
                                                sortable={true}
                                                filter={true}/>
                                            <Column
                                                field="ugt.ugd_name"
                                                header="Derece"
                                                sortable={true}
                                                filter={true}/>
                                            <Column
                                                field="upg_starttime"
                                                body={this.starttimeTemplate}
                                                header="Başlama Tarihi"
                                                sortable={true}
                                            />
                                            <Column
                                                field="upg_graduationtime"
                                                header="Bitirme Tarihi"
                                                body={this.graduationtimeTemplate}
                                                sortable={true}
                                            />
                                        </DataTable>

                                        <div className="p-col-12 p-md-4">
                                            <Dialog header="Yeni Eğitim Bilgileri Ekle"
                                                    visible={this.state.graduation_popup_visibility}
                                                    style={{width: '40vw'}}
                                                    onHide={() => this.setState({graduation_popup_visibility: false})}>


                                                <div className="p-grid">
                                                    <div className="p-grid p-md-10" style={{marginTop: '10px'}}
                                                         align="left">
                                                        <div className="p-col-12 p-md-3" align="left">
                                                            <label htmlFor="input">Öğrenim:</label>
                                                            <span style={{color: "red"}}> (*)</span>
                                                        </div>
                                                        <div className="p-grid p-md-9">
                                                            <Dropdown
                                                                options={graduationItems}
                                                                inputId="ugt_id"
                                                                name="ugt_id"
                                                                style={{width: '100%'}}
                                                                onChange={this.logChange}
                                                                value={this.state.ugt_id}
                                                                showClear={true}
                                                                placeholder="Öğrenim Düzeyi Seçiniz"/>

                                                        </div>

                                                        <div className="p-col-12 p-md-3" align="left">
                                                            <label htmlFor="input">Okul Adı:</label>
                                                            <span style={{color: "red"}}> (*)</span>
                                                        </div>
                                                        <div className="p-col-12 p-md-9">
                                                            <InputText
                                                                id="upg_schoolname"
                                                                name="upg_schoolname"
                                                                value={this.state.upg_schoolname}
                                                                onChange={this.logChange}/>
                                                        </div>
                                                        <div className="p-col-12 p-md-3" align="left">
                                                            <label htmlFor="input">Başlama Zamanı </label>
                                                            <span style={{color: "red"}}> (*)</span>

                                                        </div>
                                                        <div className="p-col-12 p-md-9">
                                                            <Calendar

                                                                id="upg_starttime"
                                                                value={this.state.upg_starttime}
                                                                locale="tr"
                                                                style={{position: 'fixed', zIndex: 4}}
                                                                name="upg_starttime"
                                                                dateFormat="dd/mm/yy"
                                                                showIcon
                                                                onChange={this.logChange}
                                                                monthNavigator={true}
                                                                yearNavigator={true}
                                                                yearRange={'1910: ' + this.nowDate}/>
                                                        </div>
                                                        <div className="p-col-12 p-md-3" align="left">
                                                            <label htmlFor="input">Bitiş Zamanı</label>
                                                            <span style={{color: "red"}}> (*)</span>

                                                        </div>
                                                        <div className="p-col-12 p-md-9">
                                                            <Calendar
                                                                minDate={minDate}
                                                                id="upg_graduationtime"
                                                                value={this.state.upg_graduationtime}
                                                                locale="tr"
                                                                style={{position: 'fixed', zIndex: 3}}
                                                                name="upg_graduationtime"
                                                                dateFormat="dd/mm/yy"
                                                                onChange={this.logChange}
                                                                monthNavigator={true}
                                                                yearNavigator={true}
                                                                showIcon
                                                                yearRange={'1910: ' + this.nowDate}/>
                                                        </div>

                                                    </div>
                                                    <div className="p-col-12 p-md-4">
                                                        <Button
                                                            icon="pi pi-check"
                                                            type="button"
                                                            onClick={this.addUpdateGraduation}
                                                            label="Ekle"/>
                                                    </div>
                                                    <div className="p-g-12 p-md-4">
                                                        <Button
                                                            type="reset"
                                                            icon="pi pi-times"
                                                            onClick={() => this.setState({graduation_popup_visibility: false})}
                                                            label="Vazgeç"
                                                            className="p-button-secondary"/>
                                                    </div>
                                                </div>
                                            </Dialog>
                                            <Button
                                                type="button"
                                                icon="pi pi-plus-circle"
                                                label="Yeni Eğitim Ekle"
                                                onClick={() => this.setState({
                                                    graduation_row_index: null,
                                                    upg_schoolname: '',
                                                    upg_graduationtime: null,
                                                    upg_starttime: null,
                                                    ugt_id: null,
                                                    graduation_popup_visibility: true,

                                                })}/>
                                        </div>


                                    </Panel>

                                    <Panel header="İletişim Bilgileri" toggleable={true}>
                                        <div className="p-grid datatable-responsive-demo">
                                            <DataTable
                                                emptyMessage="Kayıt Bulunamadı"
                                                value={this.state.contacts}
                                                className="p-datatable-responsive-demo"
                                                reorderableColumns={true}>
                                                <Column
                                                    header="İşlevler"
                                                    body={this.contacttypeButtons.bind(this)}
                                                    style={{textAlign: 'center', width: '6em'}}/>
                                                <Column
                                                    field="ctyp.ctyp_name"
                                                    header="İletişim Türü"
                                                    sortable={true}
                                                    filter={true}/>
                                                <Column
                                                    field="pcon_content"
                                                    header="İçerik"
                                                    sortable={true}
                                                    filter={true}/>
                                            </DataTable>
                                            <div className="p-col-12 p-md-12">
                                                <Dialog header="Yeni İletişim Bilgileri Ekle"
                                                        visible={this.state.display}
                                                        style={{width: '40vw'}}
                                                        onHide={() => this.onHideContactDialog()} maximizable>

                                                    <div className="p-grid" style={{minHeight: '15em'}}>
                                                        <div className="p-col-12">
                                                            <Dropdown
                                                                options={contactTypesItems}
                                                                inputId="contacttype"
                                                                name="contacttype"
                                                                onChange={this.logChange}
                                                                value={this.state.contacttype}
                                                                showClear={true}
                                                                placeholder="İletişim Türünü Seçiniz"/>

                                                        </div>
                                                        <div className="p-col-12">
                                                            {this.contact_type_input()}
                                                        </div>
                                                        <div className="p-col-12">
                                                            <div className="p-grid">
                                                                <div className="p-col-6">
                                                                    <Button
                                                                        icon="pi pi-check"
                                                                        type="button"
                                                                        onClick={this.addContact}
                                                                        label="Ekle"/>
                                                                </div>
                                                                <div className="p-col-6">
                                                                    <Button
                                                                        type="reset"
                                                                        icon="pi pi-times"
                                                                        onClick={() => this.onHideContactDialog()}
                                                                        label="Vazgeç"
                                                                        className="p-button-secondary"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Dialog>
                                                <div className="p-col-12 p-md-4" align="left">

                                                    <Button
                                                        type="button"
                                                        icon="pi pi-plus-circle"
                                                        label="Yeni İletişim Ekle"
                                                        onClick={() => this.setState({display: true})}/>
                                                </div>
                                            </div>
                                        </div>
                                    </Panel>
                                </center>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-2" align="left">
                            <Button
                                label="Kaydet"
                                icon="pi pi-save"/>
                        </div>
                    </form>
                </div>

                <div className="content-section implementation">
                    <Dialog header="İletişim Bilgileri Düzenle" visible={this.state.contact_info_edit}
                            modal={true} width="450px" onHide={() => this.setState({contact_info_edit: false})}>
                        <div className="p-grid">
                            <div className="p-col-12 p-md-10">
                                <div className="p-col-12 p-md-10">
                                    <InputText
                                        id="contact_edit_content"
                                        value={this.state.contact_edit_content}
                                        onChange={this.logChange}
                                        name="contact_edit_content"/>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-4">
                                <Button
                                    icon="pi pi-check"
                                    onClick={this.saveUpdateContact} type="button"
                                    label="Güncelle"/>
                            </div>
                            <div className="p-g-12 p-md-4">
                                <Button
                                    type="reset"
                                    icon="pi pi-times"
                                    onClick={() => this.setState({contact_info_edit: false})}
                                    label="Vazgeç"
                                    className="p-button-secondary"/>
                            </div>
                        </div>
                    </Dialog>
                </div>

                <div className="content-section implementation">
                    <Dialog header="Uyarı!" visible={this.state.delete_popup} style={{width: '45vw'}}
                            footer={delete_popup_footer} onHide={this.deletePopupHide}>
                        Silmek İstediğinizden Emin Misiniz!
                    </Dialog>
                </div>

                <div className="content-section implementation">
                    <Dialog
                        header="Uyarı!"
                        visible={this.state.delete_graduation_popup}
                        style={{width: '45vw'}}
                        footer={delete_graduation_popup_footer}
                        onHide={() => this.setState({delete_graduation_popup: false})}>
                        Silmek İstediğinizden Emin Misiniz!
                    </Dialog>
                </div>
            </div>
        );

    }
}


const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getInstitutions: () => {
            return dispatch(management.fetchInstitution());
        },
        selectUser: (id) => {
            return dispatch(management.selectUser(id));
        },
        updateUserProfile: (user_id, person_data) => {
            return dispatch(management.updateUserProfile(user_id, person_data));
        },
        getDeleteContact: (pcon_id) => {
            return dispatch(management.deleteContact(pcon_id));
        },
        updatePersonContact: (pcon_id, edit_contact_data) => {
            return dispatch(management.updatePersonContact(pcon_id, edit_contact_data));
        },
        logout: () => dispatch(auth.logout()),

        loadUser: () => {
            return dispatch(auth.loadUser());
        },
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);



// WEBPACK FOOTER //
// ./src/pages/userpages/UserProfile.jsx